// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"074fee3e","483":"39329f38","816":"29458914","957":"e3694e7c"}[chunkId] + ".chunk.js";
};